// components/WatchPurchaseGrid.js
import React from 'react';
import styles from './WatchPurchaseGrid.module.scss';

const WatchPurchaseGrid6 = () => {
  const watchBrands = [
    {
      name: "Zlatnike iz svih perioda",
      image: "assets/images/coin.jpg",
      models: ["Carski, kraljevski, austrougarski, jugoslovenski i strani"]
    },
    {
      name: "Srebrnjake i kolekcionarske kovanice",
      image: "assets/images/srebrnjak.jpg",
      models: [""]
    },
    {
      name: "Antički i srednjovekovni novac",
      image: "assets/images/srednjivek.jpg",
      models: [""]
    },
    {
      name: "Numizmatičke kolekcije i retke primerke",
      image: "assets/images/kolekcija.jpg",
      models: [""]
    },
    {
      name: "Dijamante",
      image: "assets/images/dijamant.jpg",
      models: [""]
    }
  ];

  const handleClick = (brandName) => {
    const urlName = brandName.toLowerCase().replace(/\s+/g, "-"); // "Audemars Piguet" -> "audemars-piguet"
    window.location.href = `/brands/${urlName}`;
  };

  return (
    <section className={styles.watchPurchaseGrid}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>🪙 Zlatnike i star novac</h2>

        <div className={styles.grid}>
          {watchBrands.map((brand, index) => (
            <div key={index} className={styles.brandCard}>
              <div className={styles.brandHeader}>
                <h3>OTKUPLJUJEMO</h3>
                <h4>{brand.name}</h4>
                {/*<p>satova</p>*/}
              </div>

              <div className={styles.brandImage}>
                <img src={brand.image} alt={brand.name} />
              </div>

              <div className={styles.models}>
                {brand.models.map((model, idx) => (
                  (
                    idx === brand.models.length - 1 ?
                      <span>{model}</span>
                      :
                      <span>{model}, </span>
                  )
                ))}
              </div>

              <button className={styles.inquiryBtn} onClick={() => handleClick(brand.name)}>Saznaj više</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WatchPurchaseGrid6;